import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router";
import { createTheme, CssBaseline, ThemeProvider, Typography } from '@mui/material';
import MainPage from './components/pages/MainPage/MainPage';
import ScenePage from './components/pages/ScenePage/ScenePage';
import NativeSandboxPage from './components/pages/NativeSandboxPage/NativeSandboxPage';
import LinkBehaviour from './components/shared/LinkBehaviour/LinkBehaviour';

const App: React.FC = () => {

    const theme = React.useMemo(
        () => createTheme({
            palette: { mode: "dark" },
            components: {
                MuiLink: {
                    defaultProps: {
                        component: LinkBehaviour,
                        underline: "hover",
                    },
                    styleOverrides: {
                        root: {
                            color: "#ffffff"
                        }
                    }
                }
            }
        }),
        []
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<MainPage />} />
                        <Route path="/scene/:name" element={<ScenePage />} />
                        <Route path="/native-sandbox" element={<NativeSandboxPage />} />
                        <Route path="*" element={<Typography>Not found ¯\_(ツ)_/¯</Typography>} />
                    </Routes>
                </BrowserRouter>
            </CssBaseline>
        </ThemeProvider>
    )
};

export default App
